import { FCM_TOKENS_ENDPOINT } from 'features/push-notification/constants';
import type {
  TDeletePushSubscriptionPayload,
  TPushSubscriptionPayload,
} from 'features/push-notification/types';
import { baseApi } from 'lib/rtkQuery/baseApi';

export const pushNotificationApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    /** Upsert FCM token — BE: POST /me/push-subscriptions */
    SavePushSubscription: builder.mutation<void, TPushSubscriptionPayload>({
      query: body => ({
        url: FCM_TOKENS_ENDPOINT,
        method: 'POST',
        data: body,
      }),
    }),

    /** Xoá token — BE: DELETE /me/push-subscriptions */
    DeletePushSubscription: builder.mutation<
      void,
      TDeletePushSubscriptionPayload
    >({
      query: body => ({
        url: FCM_TOKENS_ENDPOINT,
        method: 'DELETE',
        data: body,
      }),
    }),
  }),
});

export const {
  useSavePushSubscriptionMutation,
  useDeletePushSubscriptionMutation,
} = pushNotificationApi;
